<template>
  <!-- this template is just for copy & paste -->
  <v-dialog
    v-model="opened"
    :transition="false"
    :max-width="600"
    :persistent="false"
  >
    <!-- @click:outside="!$async.---.$pending ? close() : () => {}" -->
    <v-card>
      <v-card-title class="headline"></v-card-title>
      <v-card-text></v-card-text>
      <v-card-actions>
        <slot name="actions">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="grey darken-2"
          >cancel</v-btn>
          <v-btn
            text
            color="primary darken-2"
          >OK</v-btn>
          </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'DialogAbstract',
  data () {
    return {
      opened: false
    }
  },
  watch: {
    opened (val) {
      const event = !val ? 'closed' : 'opened'
      this.$emit(event)
    }
  },
  methods: {
    open () {
      this.opened = true
    },
    close () {
      this.opened = false
    }
  }
}
</script>
